import { ColumnType } from '@thoughtspot/ts-chart-sdk';
import _ from 'lodash';
import { ChartSpecificColumnTypeToColumnTypeMap, ColumnTypeToEffectiveTypeMap, } from '../events/ts-to-chart/get-data-query/types';
import { AnswerColumnEffectiveType, } from '../types/prism';
const DATA_LIMIT_EXCEED_ERROR_CODES = ['11049', '11050', '11051', '11052', '11053'];
const hasErrorCode = (error) => {
    return (typeof error === 'object' &&
        error !== null &&
        'code' in error &&
        (typeof error.code === 'string' || typeof error.code === 'number'));
};
export const isDataLimitExceedError = (error) => {
    return hasErrorCode(error) && DATA_LIMIT_EXCEED_ERROR_CODES.includes(String(error.code));
};
const PRISM_DIMENSIONS = {
    x: 'x',
    y: 'y',
    measureValues: 'measureValues',
};
export const mapSDKQueryToDataQueryInput = (queries) => {
    if (_.isEmpty(queries)) {
        return null;
    }
    const dataQueryInput = {
        queries: queries.map((query) => {
            const { queryColumns } = query;
            return {
                query: queryColumns.map((col) => {
                    let type = ColumnTypeToEffectiveTypeMap[col.type];
                    if (col.type === ColumnType.VIRTUAL) {
                        type =
                            ChartSpecificColumnTypeToColumnTypeMap[col.chartSpecificColumnType];
                    }
                    let dimension;
                    if (col.isMeasureValue) {
                        dimension = PRISM_DIMENSIONS.measureValues;
                    }
                    else if (type === AnswerColumnEffectiveType.Measure) {
                        dimension = PRISM_DIMENSIONS.y;
                    }
                    else {
                        dimension = PRISM_DIMENSIONS.x;
                    }
                    return {
                        id: col.id,
                        type,
                        dimension,
                    };
                }),
                queryParam: {
                    pagination: {
                        offset: query.queryParams?.offset ?? undefined,
                        size: query.queryParams?.size ?? undefined,
                    },
                },
            };
        }),
    };
    return dataQueryInput;
};
//# sourceMappingURL=data-query.util.js.map